module.exports = __webpack_public_path__ + "img/banner.2b1c0405.png";